"use client";

import React from "react";
import { Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Sustainability() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="80316" id="policy-introduction" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={ref} className={`flex flex-col items-center text-center gap-10 transition-all duration-200 ease-smooth ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {/* Visual Header Element */}
          <div className="w-full relative">
            
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-background p-4 shadow-medium border border-border rounded-md">
              <Leaf className="size-8 text-secondary" />
            </div>
          </div>

          {/* Content Section */}
          <div className="flex flex-col items-center gap-6 max-w-2xl mt-4">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-primary font-display">
              EFT Safeguarding Policy
            </h2>
            <div className="w-[60px] h-[4px] bg-secondary -mt-4 mb-2" />
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
              Our commitment to the safety and well-being of every individual is at the core of our mission. This policy outlines our rigorous standards and procedures to ensure a protected environment for all participants, staff, and community partners.
            </p>
            <Button size="lg" className="mt-2 bg-primary hover:bg-primary-hover text-foreground-primary transition-all shadow-soft hover:shadow-medium" asChild>
              <Link to="/PrivacyPolicyPage">
                View Full Policy Details
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}